var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loading
    ? _c("campaigns-loader")
    : _c(
        "div",
        {
          staticClass: "container-fluid",
          attrs: { id: "campaigns-container" },
        },
        [
          _c(
            "b-row",
            { staticClass: "justify-content-center px-md-4" },
            [
              _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c("page-header", {
                    attrs: {
                      subtitle: _vm.$t("campaigns.subtitle"),
                      size: "col-10",
                      "container-class": "mb-4",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "title",
                        fn: function () {
                          return [
                            _c(
                              "h2",
                              {
                                staticClass:
                                  "page-header pendo--badge-target-wrapper",
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.$t("campaigns.title")) +
                                    "\n            "
                                ),
                                _c(
                                  "span",
                                  { attrs: { id: "campaign-tooltip" } },
                                  [
                                    _c("icon", {
                                      staticClass: "tooltip-info",
                                      attrs: { name: "question-circle" },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ]
                        },
                        proxy: true,
                      },
                      {
                        key: "inlinebuttons",
                        fn: function () {
                          return [
                            _c(
                              "b-col",
                              {
                                staticClass:
                                  "d-flex flex-column align-items-end",
                                attrs: { cols: "2" },
                              },
                              [
                                _c(
                                  "plan-simple-button",
                                  {
                                    attrs: {
                                      "class-name": "btn-sm d-lg-inline d-none",
                                      page: _vm.accountPlanPage,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.$router.push(
                                          _vm.addCampaignLink
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.$t(
                                            "campaigns.actions.createCampaign"
                                          )
                                        ) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-dropdown",
                                  {
                                    staticClass: "d-flex d-lg-none",
                                    attrs: {
                                      variant: "transparent",
                                      "toggle-class":
                                        "text-gray position-static p-0",
                                      "no-caret": "",
                                      right: "",
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "button-content",
                                        fn: function () {
                                          return [
                                            _c(
                                              "i",
                                              { staticClass: "material-icons" },
                                              [_vm._v("more_vert")]
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ]),
                                  },
                                  [
                                    _vm._v(" "),
                                    _c(
                                      "b-dropdown-item",
                                      {
                                        staticClass: "text-center",
                                        on: { click: _vm.goToAddCampaign },
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.$t(
                                                "campaigns.actions.createCampaign"
                                              )
                                            ) +
                                            "\n              "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("campaigns-table"),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }